import {
  Event,
  Identifiable,
  Milestone,
  Project,
  Unavailability,
  CalendarHolidays,
  Task,
} from "@planzone/dto";

type Calendar = {
  events: (Identifiable<Event> & { project: Identifiable<Project> })[];
  milestones: (Identifiable<Milestone> & { project: Identifiable<Project> })[];
  unavailabilities: Identifiable<Unavailability>[];
  calendarsHolidays: Identifiable<CalendarHolidays>[];
  tasks: (Identifiable<Task> & { project: Identifiable<Project> })[];
};

const calendar: Calendar = {
  events: [],
  milestones: [],
  unavailabilities: [],
  calendarsHolidays: [],
  tasks: [],
};

export type { Calendar };

export { calendar };
